export default __webpack_public_path__ + "static/media/Credit_Card_Icon.6d3db9cf.svg";